package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FinanceTransactionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    verdict: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(40_470_983, arrayOf("finance_transaction"), driver,
      "FinanceTransaction.sq", "selectAll",
      "SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction WHERE is_deleted = 0 ORDER BY date DESC, created_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectAll(): Query<Finance_transaction> = selectAll { id, date, account_id,
      to_account_id, cat_id, type, amount, description, fund_id, verdict, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByAccount(acc: String, mapper: (
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    verdict: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByAccountQuery(acc) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByAccount(acc: String): Query<Finance_transaction> = selectByAccount(acc) { id,
      date, account_id, to_account_id, cat_id, type, amount, description, fund_id, verdict,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBetween(
    from: String,
    to: String,
    mapper: (
      id: String,
      date: String,
      account_id: String,
      to_account_id: String?,
      cat_id: String?,
      type: String,
      amount: Long,
      description: String?,
      fund_id: String?,
      verdict: String?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectBetweenQuery(from, to) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectBetween(from: String, to: String): Query<Finance_transaction> =
      selectBetween(from, to) { id, date, account_id, to_account_id, cat_id, type, amount,
      description, fund_id, verdict, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    verdict: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectById(id: String): Query<Finance_transaction> = selectById(id) { id_, date,
      account_id, to_account_id, cat_id, type, amount, description, fund_id, verdict, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id_,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    verdict: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(240_599_672, arrayOf("finance_transaction"), driver,
      "FinanceTransaction.sq", "selectDirty",
      "SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectDirty(): Query<Finance_transaction> = selectDirty { id, date, account_id,
      to_account_id, cat_id, type, amount, description, fund_id, verdict, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    verdict: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getLong(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getString(9),
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Finance_transaction> = selectByIdAnyState(id) {
      id_, date, account_id, to_account_id, cat_id, type, amount, description, fund_id, verdict,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_transaction(
      id_,
      date,
      account_id,
      to_account_id,
      cat_id,
      type,
      amount,
      description,
      fund_id,
      verdict,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectVerdictsBetween(
    date: String,
    date_: String,
    mapper: (verdict: String, n: Long) -> T,
  ): Query<T> = SelectVerdictsBetweenQuery(date, date_) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!
    )
  }

  public fun selectVerdictsBetween(date: String, date_: String): Query<SelectVerdictsBetween> =
      selectVerdictsBetween(date, date_) { verdict, n ->
    SelectVerdictsBetween(
      verdict,
      n
    )
  }

  public fun insert(
    id: String,
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_376_869_175, """
        |INSERT INTO finance_transaction(
        |    id, date, account_id, to_account_id, cat_id, type, amount, description, fund_id, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindString(1, date)
          bindString(2, account_id)
          bindString(3, to_account_id)
          bindString(4, cat_id)
          bindString(5, type)
          bindLong(6, amount)
          bindString(7, description)
          bindString(8, fund_id)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(1_376_869_175) { emit ->
      emit("finance_transaction")
    }
  }

  public fun update(
    date: String,
    account_id: String,
    to_account_id: String?,
    cat_id: String?,
    type: String,
    amount: Long,
    description: String?,
    fund_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_721_815_367, """
        |UPDATE finance_transaction
        |SET date = ?, account_id = ?, to_account_id = ?, cat_id = ?, type = ?, amount = ?, description = ?, fund_id = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 10) {
          bindString(0, date)
          bindString(1, account_id)
          bindString(2, to_account_id)
          bindString(3, cat_id)
          bindString(4, type)
          bindLong(5, amount)
          bindString(6, description)
          bindString(7, fund_id)
          bindLong(8, updated_at)
          bindString(9, id)
        }
    notifyQueries(1_721_815_367) { emit ->
      emit("finance_transaction")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_979_430_925,
        """UPDATE finance_transaction SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_979_430_925) { emit ->
      emit("finance_transaction")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_126_348_336,
        """UPDATE finance_transaction SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_126_348_336) { emit ->
      emit("finance_transaction")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(2_135_474_164, """DELETE FROM finance_transaction WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(2_135_474_164) { emit ->
      emit("finance_transaction")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-776_537_307,
        """UPDATE finance_transaction SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-776_537_307) { emit ->
      emit("finance_transaction")
    }
  }

  public fun updateVerdict(
    verdict: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(43_803_282,
        """UPDATE finance_transaction SET verdict = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, verdict)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(43_803_282) { emit ->
      emit("finance_transaction")
    }
  }

  private inner class SelectByAccountQuery<out T : Any>(
    public val acc: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_transaction", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_transaction", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-889_867_908, """
    |SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction
    |WHERE is_deleted = 0
    |  AND (account_id = ? OR to_account_id = ?)
    |ORDER BY date DESC, created_at DESC
    """.trimMargin(), mapper, 2) {
      bindString(0, acc)
      bindString(1, acc)
    }

    override fun toString(): String = "FinanceTransaction.sq:selectByAccount"
  }

  private inner class SelectBetweenQuery<out T : Any>(
    public val from: String,
    public val to: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_transaction", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_transaction", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_695_414_574, """
    |SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction
    |WHERE is_deleted = 0 AND date >= ? AND date <= ?
    |ORDER BY date DESC, created_at DESC
    """.trimMargin(), mapper, 2) {
      bindString(0, from)
      bindString(1, to)
    }

    override fun toString(): String = "FinanceTransaction.sq:selectBetween"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_transaction", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_transaction", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_254_641_772,
        """SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceTransaction.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_transaction", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_transaction", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-525_125_999,
        """SELECT finance_transaction.id, finance_transaction.date, finance_transaction.account_id, finance_transaction.to_account_id, finance_transaction.cat_id, finance_transaction.type, finance_transaction.amount, finance_transaction.description, finance_transaction.fund_id, finance_transaction.verdict, finance_transaction.created_at, finance_transaction.updated_at, finance_transaction.is_deleted, finance_transaction.deleted_at, finance_transaction.synced_at FROM finance_transaction WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceTransaction.sq:selectByIdAnyState"
  }

  private inner class SelectVerdictsBetweenQuery<out T : Any>(
    public val date: String,
    public val date_: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_transaction", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_transaction", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_219_455_980, """
    |SELECT verdict, COUNT(*) AS n FROM finance_transaction
    |WHERE is_deleted = 0 AND verdict IS NOT NULL AND date >= ? AND date <= ?
    |GROUP BY verdict
    """.trimMargin(), mapper, 2) {
      bindString(0, date)
      bindString(1, date_)
    }

    override fun toString(): String = "FinanceTransaction.sq:selectVerdictsBetween"
  }
}
